<script>
  import { currentUser } from '../../stores';
  import { fetchUsers } from '../../api';
  import { fade } from 'svelte/transition';
  import { Loaders } from '@shopboxai/sb-portal-components';
  import UserAccessBadge from './UserAccessBadge.svelte';
  import UserAccessUpdate from './UserAccessUpdate.svelte';
  import UserAccessDelete from './UserAccessDelete.svelte';
  import UserAccessInvite from './UserAccessInvite.svelte';

  const _fetchUsers = async () => {
    let rows = [];
    const users = await fetchUsers();
    rows = users.map((user) => {
      delete user.permissions.config;
      return {
        email: user.email,
        permissions: user.permissions,
        user_id: user.id,
        shopbox_admin: user.shopbox_admin,
      };
    });
    return rows;
  };
  let runFetchUsers = _fetchUsers();

  const handleComplete = async () => {
    runFetchUsers = _fetchUsers();
  };
</script>

<div class="main">
  <div class="header">
    <h3>Users & Access</h3>
    <UserAccessInvite on:complete={handleComplete} />
  </div>

  <div class="table sb-scrollbar sb-scrollbar-horizontal">
    <table>
      {#await runFetchUsers}
        <Loaders items={[{ size: 20, height: '150px' }]} />
      {:then rows}
        <tbody>
          {#each rows as row}
            <tr in:fade>
              {#if $currentUser.isShopBoxAdmin == true}
                <td> {row.email}</td>
                <td> <UserAccessBadge {row} /></td>
                <td>
                  <UserAccessUpdate
                    data={{
                      permissions: row.permissions,
                      user_id: row.user_id,
                      email: row.email,
                    }}
                    on:complete={handleComplete}
                  />
                  <UserAccessDelete data={{ email: row.email, user_id: row.user_id }} on:complete={handleComplete} />
                </td>
              {:else if row.shopbox_admin == false}
                <td> {row.email}</td>
                <td> <UserAccessBadge {row} /></td>
                <td>
                  <UserAccessUpdate
                    data={{
                      permissions: row.permissions,
                      user_id: row.user_id,
                      email: row.email,
                    }}
                    on:complete={handleComplete}
                  />
                  <UserAccessDelete data={{ email: row.email, user_id: row.user_id }} on:complete={handleComplete} />
                </td>
              {/if}
            </tr>
          {/each}
        </tbody>
      {:catch}
        <h3>No users</h3>
      {/await}
    </table>
  </div>
</div>

<style>.header{color:var(--t-c);display:flex;justify-content:space-between}.main{border:1px solid #d0d0d2;border-radius:4px;gap:16px;margin-top:25px;padding:12px}.table{color:var(--t-c);margin-top:10px;overflow-y:scroll;width:100%}.table :global(table){border-collapse:collapse;width:100%}tr{border-bottom:1px solid #ddd}.table td{font-size:14px;padding:11px 1em 11px 0;text-align:left}.table tr:last-of-type{border-bottom:none}.table tr>td:last-child{text-align:right;white-space:nowrap}@media (max-width:600px){.table{overflow:hidden}tr{display:grid;position:relative}tr>td:last-child{margin-top:-4px;padding-right:0;position:absolute;right:0}}</style>
